import React from 'react';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {useEffect} from 'react';
import {useRef} from 'react';

// react-bootstrap components
import {
  Button,
  Card,
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import axios from 'components/Axios/Axios.js';
import dayGridPlugin from '@fullcalendar/daygrid';
import DNS from 'components/DNS/dns.js';
import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import {isMobile, isTablet} from 'react-device-detect';
// import {DateRange} from 'react-date-range';

// import {fr, enUS} from 'react-date-range/src/locale/index';
import ModalVIEWDELETEReservation from './multiappReservationVIEWDELETE';
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import {DesktopDatePicker} from '@mui/x-date-pickers';
import {translations} from '../../../i18n/translations';
import TextField from '@mui/material/TextField';
import {Popper} from '@mui/material';

// import DatePickerComponent from 'components/DateTime/DatePicker';

/**
 * This function handle all the event and style in the reservation page.
 * @function Reservations
 * @return {HTML} the reservation's page.
 */
function MultiappReservation() {
  const {t} = useTranslation();
  const token = useSelector((state) => state.token);
  // const user = useSelector((state) => state.user);
  const animatedComponents = makeAnimated();

  const [showEventTitle, setEventTitle] = useState('');
  const [showEventName, setEventName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const [showSalle, setSalle] = useState([]);
  const [showSalleValue, setSalleValue] = useState([]);
  const [showSalleValueSelected, setSalleValueSelected] = useState([]);
  const [showResPk, setResPk] = useState('');
  const [showDisplayDateRange2, setDisplayDateRange2] = useState('none');
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  {
    /* Modal for Create method */
  }
  const [showCreatedBy, setCreatedBy] = useState({entreprise: ''});
  const [showDebutDate, setDebutDate] = useState('');
  const [showDebutTime, setDebutTime] = useState('');
  const [showEndTime, setEndTime] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Disposition de la Salle
  const [showSelectedDisposition, setSelectedDisposition] = useState([]);
  const [showAllDisposition, setAllDisposition] = useState([]);
  const [showAllServices, setAllServices] = useState([]);
  const [showDescription, setDescription] = useState('');
  const [showStartWeekDate, setStartWeekDate] = useState(Date());
  const [showEndWeekDate, setEndWeekDate] = useState(Date());
  // const [showFilterEntreprise, setFilterEntreprise] = useState(false);
  const calendarRef = React.createRef(FullCalendar);
  const [showReservedIds, setReservedIds] = useState([]);
  // const [showUrlPkBuilding, setUrlPkBuilding] = useState();
  const buttonRef = useRef(null);

  // Room Service
  const [showSelectedRoomService, setSelectedRoomService] = useState([]);

  const [showModal2, setShowModal2] = useState(false);
  {
    /* Modal for View method */
  }

  const [LReservations, setReservations] = useState(
      {
        data: null,
        error: false,
      },
      [],
  );

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };
  const requestOptionsAxiosGet = {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'token ' + token['tokenRedux'],
    },
  };

  const setInfoFromUrl = () => {
    const url = window.location.href;
    const Infos = url.split('/')[3];

    const ParsedBuilding = Infos.split('?')[1];
    const pkBuilding = ParsedBuilding.split('!')[0];
    const buildingName = ParsedBuilding.split('!')[1];

    // const Building = toConvert.replace(/-/g, ' ');

    console.log('Building', pkBuilding, buildingName);
    return pkBuilding;
  };


  useEffect(() => {
    // setInfoFromUrl();
    const calendarApi = calendarRef.current.getApi();
    const type = moment(calendarApi.getDate());
    const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
    const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
    setStartWeekDate(start);
    setEndWeekDate(end);

    getAllSalle();
    getReservations(start, end);
  }, []);

  const cleanDataReservation = () => {
    setShowModal2(false);
    setDebutDate('');
    setDebutTime('');
    setEndTime('');
    setSelectedDisposition([]);
    setSelectedRoomService([]);
    setDescription('');
    setReservedIds([]);
  };

  const getAllSalle = () => {
    const urlPkBuilding = setInfoFromUrl();
    axios
        .get(
            DNS +
          '/salle/deleteGetPatchSalle/' +
          urlPkBuilding +
          '/',
            requestOptionsAxiosGet,
        )
        .then((response) => {
          setSalle(response.data.fields);
          let tmp = [];
          response.data.fields.map((elem, key) => {
            tmp = tmp.concat({value: elem.pk, label: elem.name});
          });
          setSalleValue(tmp);
        });
  };

  const getSalle = (dates=[], start, end, salleIds = []) => {
    const urlPkBuilding = setInfoFromUrl();
    axios
        .post(
            `${DNS}/salle/getSalleAvailable/${urlPkBuilding}/`,
            {
              dates: dates, // array of YYYY-MM-DD strings
              start: start, // string like "09:00"
              end: end, // string like "11:00"
              salleIds: salleIds, // array of integers
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'token ' + token['tokenRedux'],
              },
            },
        )
        .then((response) => {
          setSalle(response.data.fields);
        })
        .catch((error) => console.log('Error fetching available salles:', error));
  };

  // const getMyCreatedRerservations = (myReservation) => {
  //   let personalReservation = [];
  //   myReservation.map((singleReservation) => {
  //     if (singleReservation.createdBy.pk == user.user.pk) {
  //       personalReservation = personalReservation.concat(singleReservation);
  //     }
  //   });
  //   console.log('personalReservation: ', personalReservation, user.user.pk);
  // };


  const getReservations = (startDate, endDate) => {
    const urlPkBuilding = setInfoFromUrl();
    fetch(
        DNS +
        '/salle/deleteGetPatchReservation/' +
        urlPkBuilding +
        '/?start=' + startDate + '&end=' + endDate,
        requestOptions,
    ).then(async (response) => {
      const data = await response.json();
      if (data.fields) {
        setReservations({
          data: data.fields,
          error: false,
        });
        // getMyCreatedRerservations(data.fields);
      } else {
        setReservations({
          data: data.fields,
          error: false,
        });
        // getMyCreatedRerservations(data.fields);
      }
    });
  };


  let content = [];

  if (LReservations.error) {
    content = <p>ERROR: couldn't load reservation list properly.</p>;
  }

  if (LReservations.data) {
    content = LReservations.data
        .slice(0)
        .reverse()
        .filter((val) => {
          if (showSalleValueSelected.length != 0) {
            let tmp = false;
            val.reservedSalle.map((elem, key) => {
              showSalleValueSelected.map((e, key) => {
                if (elem.name == e.label) {
                  tmp = true;
                }
              });
            });
            if (tmp == true) {
              if (searchTerm == '') {
                return val;
              } else if (
                val.name.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return val;
              } else {
                return undefined;
              }
            }
            return undefined;
          }
          if (searchTerm == '') {
            return val;
          } else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
            return val;
          }
        })
        .map((reservation, key) => {
        // setReserved(reservation.reservedSalle[0].name)
          const calendardata = {
            id: reservation.pk,
            title: reservation.reservedSalle.map((elem, key) => {
              return (elem.name + ' ');
            }),
            start: reservation.debutDate + 'T' + reservation.debutTime,
            end: reservation.endDate + 'T' + reservation.endTime,
            color: reservation.reservedSalle[0].colorCard,
            extendedProps: {
              description: reservation.name,
              reservpk: reservation.id,
              EnbUserExpected: reservation.nbUserExpected,
              Etitle: reservation.name,
              EdebutDate: reservation.debutDate,
              EdebutTime: reservation.debutTime,
              EendTime: reservation.endTime,
              Ereserved: reservation.reservedSalle,
              createdBy: reservation.createdBy,
              WantedDisposition: reservation.WantedDisposition,
              WantedService: reservation.WantedService,
              comment: reservation.comment,
            },
          };
          return calendardata;
        });
    // console.log(content)
  }

  const handleDateClick = (arg) => {
    // bind with an arrow function
    cleanDataReservation();
    setEventTitle(arg.event.title);
    setEventName(arg.event.extendedProps.description);
    setDebutDate(arg.event.extendedProps.EdebutDate);
    setDebutTime(arg.event.extendedProps.EdebutTime);
    setEndTime(arg.event.extendedProps.EendTime);
    setResPk(arg.event.extendedProps.reservpk);
    setShowModal2(true);
    setCreatedBy(arg.event.extendedProps.createdBy);
    const salleIds = [];
    arg.event.extendedProps.Ereserved.map((elem, key) => {
      salleIds.push(elem.pk);
    });
    setReservedIds(salleIds);
    setDescription(arg.event.extendedProps.comment);
    arg.event.extendedProps.Ereserved[0]['value'] =
      arg.event.extendedProps.Ereserved[0].name;
    dropdownLinkableSalle(arg.event.extendedProps.Ereserved[0]);
    let test = [];
    let tmp = [];
    arg.event.extendedProps.Ereserved.map((value, key) => {
      if (key != 0) {
        test = test.concat(value.name);
      }
    });
    let tmp2 = [];
    arg.event.extendedProps.Ereserved[0].linkSalle.map((elem, key) => {
      tmp2 = tmp2.concat({value: elem.id, label: elem.name});
      if (test.includes(elem.name) == true) {
        tmp = tmp.concat({value: elem.id, label: elem.name});
      }
    });
    handleSalleCombinable(tmp);
    let AllDispositionsTab = [];
    let AllServicesTab = [];
    arg.event.extendedProps.Ereserved[0].AllDispositions.split(' ').map(
        (elem, key) => {
          AllDispositionsTab = AllDispositionsTab.concat({
            value: key,
            label: elem,
          });
        },
    );
    arg.event.extendedProps.Ereserved[0].AllServices.split(' ').map(
        (elem, key) => {
          AllServicesTab = AllServicesTab.concat({value: key, label: elem});
        },
    );
    setAllDisposition(AllDispositionsTab);
    setAllServices(AllServicesTab);

    tmp = [];
    arg.event.extendedProps.Ereserved.map((value, key) => {
      if (key != 0) {
        tmp = tmp.concat(value.AllServices);
      }
    });
    let listOfServices = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfServices = listOfServices.concat(value));
      });
    });
    if (listOfServices.length == 0) {
      listOfServices = listOfServices.concat('None');
      let newValue = [];
      AllServicesTab.map((elem) => {
        arg.event.extendedProps.WantedService.split(' ').map((value) => {
          elem.label == value ? (newValue = newValue.concat(elem)) : null;
        });
      });
      setSelectedRoomService(newValue);
    } else {
      AllServicesTab.map((elem, key) => {
        if (!listOfServices.includes(elem.label)) {
          listOfServices = listOfServices.concat(elem.label);
        }
      });
      tmp = [];
      listOfServices.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      let trueValue = [];
      tmp.map((elem) =>
        arg.event.extendedProps.WantedService.split(' ').map((elem2) => {
          elem.label == elem2 ?
          (trueValue = trueValue.concat(elem)) :
          null;
        }),
      );
      setSelectedRoomService(trueValue);
    }

    tmp = [];
    arg.event.extendedProps.Ereserved.map((value, key) => {
      if (key != 0) {
        tmp = tmp.concat(value.AllDispositions);
      }
    });
    let listOfDisposition = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfDisposition = listOfDisposition.concat(value));
      });
    });
    if (listOfDisposition.length == 0) {
      listOfDisposition = listOfDisposition.concat('None');
      AllDispositionsTab.map((elem) =>
        elem.label == arg.event.extendedProps.WantedDisposition ?
          setSelectedDisposition(elem) :
          null,
      );
    } else {
      AllDispositionsTab.map((elem, key) => {
        if (!listOfDisposition.includes(elem.label)) {
          listOfDisposition = listOfDisposition.concat(elem.label);
        }
      });
      tmp = [];
      listOfDisposition.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
      tmp.map((elem) =>
        elem.label == arg.event.extendedProps.WantedDisposition ?
          setSelectedDisposition(elem) :
          null,
      );
    }
  };

  const goToSpecificDate = (dateString) => {
    console.log('triggered');
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(dateString); // Déplace le calendrier à la date donnée
      const type = moment(calendarApi.getDate());
      const date2 = moment(showEndWeekDate);
      if (type > date2) {
        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
        setStartWeekDate(start);
        setEndWeekDate(end);
        getReservations(start, end);
      } else if (type < date2) {
        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
        setStartWeekDate(start);
        setEndWeekDate(end);
        getReservations(start, end);
      }
    }
  };


  const handleSalleCombinable = (e) => {
    setSelectedDisposition([]);
    setSelectedRoomService([]);
    let nbMax = 0;
    let tmp = [];
    showSalle.map((value, key) => {
      e.map((elem, nb) => {
        value.name == elem.label ?
          ((tmp = tmp.concat(value.AllServices)),
          (nbMax = nbMax + value.nbUserMax)) :
          null;
      });
    });
    let listOfServices = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfServices = listOfServices.concat(value));
      });
    });
    if (listOfServices.length == 0) {
      listOfServices = listOfServices.concat('None');
    } else {
      showAllServices.map((elem, key) => {
        if (!listOfServices.includes(elem.label)) {
          listOfServices = listOfServices.concat(elem.label);
        }
      });
      tmp = [];
      listOfServices.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
    }

    tmp = [];
    showSalle.map((value, key) => {
      e.map((elem, nb) => {
        value.name == elem.label ?
          (tmp = tmp.concat(value.AllDispositions)) :
          null;
      });
    });
    let listOfDispositions = [];
    tmp.map((elem) => {
      elem.split(' ').map((value) => {
        value == 'None' ?
          null :
          (listOfDispositions = listOfDispositions.concat(value));
      });
    });
    if (listOfDispositions.length == 0) {
      listOfDispositions = listOfDispositions.concat('None');
    } else {
      showAllDisposition.map((elem, key) => {
        if (!listOfDispositions.includes(elem.label)) {
          listOfDispositions = listOfDispositions.concat(elem.label);
        }
      });
      tmp = [];
      listOfDispositions.map((elem, key) => {
        tmp = tmp.concat({value: key, label: elem});
      });
    }
  };


  return (
    <Container fluid className="p-0 m-0">
      <style>
        {`
          html, body, #root {
            height: 100%;
            margin: 0;
            padding: 0;
            background-color: black;
            overflow: hidden;
          }

          .full-height {
            height: 90% !important;
            min-height: 100vh;
          }

          .card,
          .card-body {
            height: 100%;
            margin-bottom: 0 !important;
            border-radius: 0 !important;
          }
        `}
      </style>
      <Row>
        <Col md="12">
          <Card>
            <Card.Header className="bg-white border-bottom-0  mt-4">
              {!isMobile ?
                    <Card.Title style={{fontSize: '25pt'}} className={'text-center'}>Salle de Réunion</Card.Title> :
                    <Card.Title style={{fontSize: '25pt'}} className={'text-center'}>Salle de Réunion</Card.Title>
              }

              <p style={{fontSize: '20pt'}} className="card-category d-none d-sm-block text-center">{t(translations.MEETING_SUBTITLE3)}</p>
              <div className="row pl-0 pr-0" style={{paddingTop: '15px'}}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localStorage.i18nextLng == 'fr' ? frLocale : localStorage.i18nextLng == 'en' ? enLocale : frLocale}>
                  {/* Ternary condition restored */}
                  <Select
                    placeholder={t(translations.MEETING_SEARCH)}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    className="col-sm-12 col-12 col-md-2 col-lg-3 ml-5 mr-3 mt-5"
                    isMulti
                    options={showSalleValue}
                    onChange={(e) => setSalleValueSelected(e)}
                  />
                  <div style={{left: '7%'}} id="custom-search-input" className="col-sm-12 col-12 col-md-2 col-lg-3 mr-3 mt-5">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={t(translations.SEARCH)}
                        onChange={(event) => {
                          setSearchTerm(event.target.value);
                        }}
                      />
                      <span className="input-group-btn btn btn-warning">
                        <span className="fas fa-search"></span>
                      </span>
                    </div>
                  </div>
                  {showDisplayDateRange2 === 'none' ? (
                    <Button
                      ref={buttonRef}
                      style={{left: '14%', height: 42, marginTop: 46}}
                      className={'col-sm-12 col-12 col-md-2 col-lg-3 mr-3'}
                      onClick={() => {
                        setDisplayDateRange2('block');
                        setIsDatePickerOpen(true);
                      }}
                    >
                      {t(translations.DATE_BUTTON_OPEN)}
                    </Button>
                  ) : (
                    <Button
                      className={'col-sm-12 col-12 col-md-2 col-lg-3 mr-3'}
                      style={{left: '14%', height: 42, marginTop: 46}}
                      onClick={() => {
                        setDisplayDateRange2('none');
                        setIsDatePickerOpen(false);
                      }}
                    >
                      {t(translations.DATE_BUTTON_CLOSE)}
                    </Button>
                  )}
                  {/* Popper for dynamic positioning of the date picker */}
                  <Popper
                    open={isDatePickerOpen}
                    anchorEl={buttonRef.current}
                    placement='bottom-start' // Ensures it aligns properly under the button
                    style={{zIndex: 10000}}
                  >
                    <DesktopDatePicker
                      label={t(translations.SELECT_DATE_LABEL)}
                      inputFormat='dd/MM/yyyy'
                      value={selectedDate}
                      open={isDatePickerOpen}
                      onChange={(newDate) => {
                        if (newDate) {
                          setSelectedDate(newDate);
                          goToSpecificDate(newDate);
                        }
                        setIsDatePickerOpen(false); // Close picker after selection
                      }}
                      onClose={() => {
                        setIsDatePickerOpen(false);
                        setDisplayDateRange2('none');
                      }
                      }
                      renderInput={(params) => (
                        <TextField {...params} sx={{backgroundColor: 'white', color: 'black'}} />
                      )}
                    />
                  </Popper>
                </LocalizationProvider>

                {/* <div style={{position: 'absolute'}}>*/}
              </div>


            </Card.Header>
            <Card.Body className="p-0 m-0 mt-5">
              <FullCalendar
                ref={calendarRef}
                plugins={isMobile ? [timeGridPlugin, dayGridPlugin] : [timeGridPlugin, dayGridPlugin]}
                slotEventOverlap={true}
                height={1300}
                eventMaxStack={3}
                expandRows={true}
                nowIndicator={true}
                allDaySlot={false}
                slotDuration={'00:30:00'}
                slotMinTime={'05:00:00'}
                slotMaxTime={'22:00:00'}
                Duration={'00:00:00'}
                initialView={'timeGridWeek'}
                buttonText={{
                  month: t(translations.MONTH),
                  week: t(translations.WEEK),
                  day: t(translations.DAY),
                  list: t(translations.LIST),
                }}

                customButtons={{
                  next: {
                    click: () => {
                      const calendarApi = calendarRef.current.getApi();
                      calendarApi.next();
                      const type = moment(calendarApi.getDate());
                      const date2 = moment(showEndWeekDate);
                      if (type > date2) {
                        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
                        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
                        setStartWeekDate(start);
                        setEndWeekDate(end);
                        getReservations(start, end);
                      }
                    },
                  },
                  prev: {
                    click: () => {
                      const calendarApi = calendarRef.current.getApi();
                      calendarApi.prev();
                      const type = moment(calendarApi.getDate());
                      const date2 = moment(showStartWeekDate);
                      if (type < date2) {
                        const start = type.startOf('week').add(1, 'days').format('YYYY-MM-DD');
                        const end = type.endOf('week').add(1, 'days').format('YYYY-MM-DD');
                        setStartWeekDate(start);
                        setEndWeekDate(end);
                        getReservations(start, end);
                      }
                    },
                  },
                }}
                headerToolbar={{
                  start: 'title',
                  center: '',
                  end: isMobile || isTablet ? 'prev,next' : 'timeGridWeek,timeGridDay prev,next',
                }}
                locale={localStorage.i18nextLng == 'fr' ? 'fr' : localStorage.i18nextLng == 'en' ? 'en' : 'fr'}
                eventDisplay="list-item"
                firstDay={1}
                eventClick={handleDateClick}
                events={content}
                navLinks={true}
              />
              {/* ##################################### VIEW DELETE MODAL BELOW #################################################### */}
              <ModalVIEWDELETEReservation
                showModal={showModal2}
                setShowModal={setShowModal2}
                getReservations={getReservations}
                showResPk={showResPk}
                showEventTitle={showEventTitle}
                showEventName={showEventName}
                showDebutDate={showDebutDate}
                showDebutTime={showDebutTime}
                showEndTime={showEndTime}
                showCreatedBy={showCreatedBy}
                showSelectedDisposition={showSelectedDisposition}
                showSelectedRoomService={showSelectedRoomService}
                showDescription={showDescription}
                start={showStartWeekDate}
                end={showEndWeekDate}
                getSalle={getSalle}
                showReservedIds={showReservedIds}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default MultiappReservation;
